import { Stack, useTheme } from "@mui/material";
import { getDate, getTime } from "../../utils/utils";
import { Notification } from "../../_app/types";
import Text from "../Text";

interface Props {
  log: Notification;
}

const Log = ({ log }: Props) => {
  const theme = useTheme();

  console.log(log.message);

  return (
    <Stack direction={"row"} gap="24px" paddingY="8px">
      <Stack direction={"column"} gap="8px">
        <Text variant="regular">{getDate(log.eventTime)}</Text>
        <Text variant="s" color={theme.myTheme.colors.foreground50}>
          {getTime(log.eventTime)}
        </Text>
      </Stack>
      <Text variant="regular" style={{ whiteSpace: "break-spaces" }}>
        {log.message.replace("\\n", "\n")}
      </Text>
    </Stack>
  );
};

export default Log;
